import capitalize from 'lodash/capitalize';

export default function textCapitalize(value) {
  return capitalize(value);
}
